import axiosInstance1 from "./loginservice";
import axios from "axios";
const axiosInstance3 = axios.create({
  baseURL: "http://localhost:2000/"
});

export const cleanCustomerId = (customerId) => {
  if (!customerId) return '';
  return customerId
    .replace(/\\/g, '')
    .replace(/"/g, '')
    .trim();
};

// PMI is the default/unnamed customer — identified by the generic CUSTOMER_ID
// env constant, same convention already used inline across the app (e.g.
// componentreg.js's `isDefaultCustomer`). Gates the Plant Group feature.
export const isPmiCustomer = (customerId) => cleanCustomerId(customerId) === window._env_.CUSTOMER_ID;

export const operatorTelemetry = async (entityType, entityId, thresholddata, options = {}) => {
  try {
    const baseUrl = window._env_.SERVER_URL.replace(/\/$/, '');
    const url = `${baseUrl}/api/plugins/telemetry/${entityType}/${entityId}/timeseries/SERVER_SCOPE`;
    const config = {};
    // Optional per-call timeout so a hung request (degraded WiFi) fails fast and can be retried.
    // Default (no timeout) preserves the previous behaviour for all existing callers.
    if (options.timeout) config.timeout = options.timeout;
    const response = await axiosInstance1.post(url, thresholddata, config);
    return response.data;
  } catch (error) {
    console.error('Error during Assign operator update:', error);
    throw error;
  }
};

export const getFirstMachineActive = async (entityType, entityId, { keys, startTs, endTs, interval = 0, limit = 10000, useStrictDataTypes = false }) => {
  try {
    const baseUrl = window._env_.SERVER_URL.replace(/\/$/, '');
    const url = `${baseUrl}/api/plugins/telemetry/${entityType}/${entityId}/values/timeseries`;
    const response = await axiosInstance1.get(url, {
      params: {
        keys,
        startTs,
        endTs,
        interval,
        limit,
        useStrictDataTypes,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error during telemetry fetch:', error);
    throw error;
  }
}

export const Downtimeadd1 = async (entityType, entityId, scope, thresholddata) => {
  try {
    const baseUrl = window._env_.SERVER_URL.replace(/\/$/, '');
    const url = `${baseUrl}/api/plugins/telemetry/${entityType}/${entityId}/timeseries/${scope}`;
    const response = await axiosInstance1.post(url, thresholddata);
    return response.data;
  } catch (error) {
    console.error('Error during Device Shift update:', error);
    throw error;
  }
};

export const getMachineLock = async (entityType, entityId, { keys, useStrictDataTypes = false }) => {
  try {
    const baseUrl = window._env_.SERVER_URL.replace(/\/$/, '');
    const url = `${baseUrl}/api/plugins/telemetry/${entityType}/${entityId}/values/timeseries`;
    const response = await axiosInstance1.get(url, {
      params: {
        keys,
        useStrictDataTypes,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error during telemetry fetch:', error);
    throw error;
  }
};

export const customerbaseddevices = async (customerId, pageSize, page) => {
  try {
    const cleanedCustomerId = cleanCustomerId(customerId);
    const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
    if (!uuidRegex.test(cleanedCustomerId)) {
      throw new Error(`Invalid UUID format after cleaning: ${cleanedCustomerId}`);
    }
    const response = await axiosInstance1.get(
      `${window._env_.SERVER_URL}api/customer/${cleanedCustomerId}/devices?pageSize=${pageSize}&page=${page}`,
      {
        headers: {
          'Content-Type': 'application/json',
        },
        timeout: 0,
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error during Device:', error);
    if (error.response) {
      console.error('Response Status:', error.response.status);
      console.error('Response Data:', error.response.data);
    }
    throw error;
  }
};

export const customerbasedshift = async (customerId, key) => {
  try {
    const baseUrl = window._env_.SERVER_URL.replace(/\/$/, '');
    const cleanedCustomerId = cleanCustomerId(customerId);
    const url = `${baseUrl}/api/plugins/telemetry/CUSTOMER/${cleanedCustomerId}/values/attributes?keys=${key}`;
    const response = await axiosInstance1.get(url);
    return response.data;
  } catch (error) {
    console.error('Error during Shift latest data:', error);
    throw error;
  }
};

export const telemetrylatestdata = async (deviceId, entitytype, key) => {
  try {
    const baseUrl = window._env_.SERVER_URL.replace(/\/$/, '');
    const url = `${baseUrl}/api/plugins/telemetry/${entitytype}/${deviceId}/values/timeseries?keys=${key}&useStrictDataTypes=false`;
    const response = await axiosInstance1.get(url);
    return response.data;
  } catch (error) {
    console.error('Error during telemetry latest data:', error);
    throw error;
  }
};

export const telemetrykeydata = async (deviceId, entitytype, key, starttime, endtime) => {
  try {
    const baseUrl = window._env_.SERVER_URL.replace(/\/$/, '');
    const url = `${baseUrl}/api/plugins/telemetry/${entitytype}/${deviceId}/values/timeseries?keys=${key}&startTs=${starttime}&endTs=${endtime}&interval=0&limit=50000&useStrictDataTypes=false`;
    const response = await axiosInstance1.get(url);
    return response.data;
  } catch (error) {
    console.error('Error during telemetry key data:', error);
    throw error;
  }
};

export const Deviceattributeget = async (customerId, key) => {
  try {
    const baseUrl = window._env_.SERVER_URL.replace(/\/$/, '');
    const cleanedCustomerId = cleanCustomerId(customerId);
    const url = `${baseUrl}/api/plugins/telemetry/DEVICE/${cleanedCustomerId}/values/attributes?keys=${key}`;
    const response = await axiosInstance1.get(url);
    return response.data;
  } catch (error) {
    console.error('Error during Shift latest data:', error);
    throw error;
  }
};


export const createNewUser = async (payload) => {
  try {
    const baseUrl = window._env_.SERVER_URL.replace(/\/$/, '');
    const url = `${baseUrl}/api/user?sendActivationMail=false`;
    const response = await axiosInstance1.post(url, payload);
    return response.data;
  } catch (error) {
    console.error('Error while creating new user:', error);
    throw error;
  }
};

export const getUserActivationLink = async (customerId) => {
  try {
    const baseUrl = window._env_.SERVER_URL.replace(/\/$/, '');
    const cleanedCustomerId = cleanCustomerId(customerId);
    const url = `${baseUrl}/api/user/${cleanedCustomerId}/activationLinkInfo`;
    const response = await axiosInstance1.get(url);
    return response.data;
  } catch (error) {
    console.error('Error while getting activation link:', error);
    throw error;
  }
};

export const createPasswordForUser = async (payload) => {
  try {
    const baseUrl = window._env_.SERVER_URL.replace(/\/$/, '');
    const url = `${baseUrl}/api/noauth/activate?sendActivationMail=true`;
    const response = await axiosInstance1.post(url, payload);
    return response.data;
  } catch (error) {
    console.error('Error while creating password for new user:', error);
    throw error;
  }
};

export const getCustomerUsers = async (customerId, page = 0, pageSize = 1000000) => {
  try {
    const baseUrl = window._env_.SERVER_URL.replace(/\/$/, '');
    const cleanedCustomerId = cleanCustomerId(customerId);
    const url = `${baseUrl}/api/customer/${cleanedCustomerId}/users`;
    const params = {
      pageSize,
      page,
      sortProperty: 'createdTime',
      sortOrder: 'DESC',
    };
    const response = await axiosInstance1.get(url, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching customer users:", error);
    throw error;
  }
};

export const deleteUserById = async (userId) => {
  try {
    const baseUrl = window._env_.SERVER_URL.replace(/\/$/, '');
    const url = `${baseUrl}/api/user/${userId}`;
    const response = await axiosInstance1.delete(url);
    return response.data;
  } catch (error) {
    console.error(`Error deleting user with ID ${userId}:`, error);
    throw error;
  }
};


export const getMachineAndtOUC = async (userId) => {
  try {
    const baseUrl = window._env_.SERVER_URL.replace(/\/$/, '');
    const url = `${baseUrl}/api/user/${userId}`;
    const response = await axiosInstance1.delete(url);
    return response.data;
  } catch (error) {
    console.error(`Error deleting user with ID ${userId}:`, error);
    throw error;
  }
};

/**
 * Lightweight ThingsBoard reachability check.
 * Any HTTP response (even 401/403/404) means the TB server is up and reachable.
 * Only a network error / timeout (no response) means TB is down/unreachable.
 * Uses plain axios (not the auth instance) so a 401 doesn't trigger a logout redirect.
 */
export const checkServerHealth = async () => {
  try {
    const baseUrl = window._env_.SERVER_URL.replace(/\/$/, '');
    await axios.get(`${baseUrl}/api/auth/user`, { timeout: 8000 });
    return true;
  } catch (error) {
    return !!error.response; // responded => up; no response => down
  }
};

/**
 * Is there any working network at all (independent of ThingsBoard)?
 * Some kiosk/HMI browsers keep navigator.onLine = true even when WiFi is cut,
 * so we actively probe a lightweight, always-up endpoint. `no-cors` means we
 * don't need a CORS header — the request resolving at all proves connectivity;
 * a network failure/timeout rejects it.
 */
export const checkInternet = async () => {
  const controller = new AbortController();
  const t = setTimeout(() => controller.abort(), 5000);
  try {
    await fetch('https://www.gstatic.com/generate_204', {
      mode: 'no-cors',
      cache: 'no-store',
      signal: controller.signal,
    });
    return true;
  } catch {
    return false;
  } finally {
    clearTimeout(t);
  }
};

export const getMachineInfo = async () => {
  try {
    const url = "/read_files"; // hardcoded endpoint
    const response = await axiosInstance3.get(url);
    return response.data; // { Touch, machine_id, machine_name }
  } catch (error) {
    console.error("Error fetching machine info:", error);
    throw error;
  }
};